import { Link, LinkProps } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { getLocalizedPath } from '@/utils/localizedRoutes';
import { forwardRef, useCallback } from 'react';
import { preloadRoute } from '@/utils/routePreloader';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

export const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  ({ to, children, onMouseEnter, ...props }, ref) => {
    const { language } = useLanguage();
    
    // Get the localized path using the centralized utility
    const localizedPath = getLocalizedPath(to, language);
    
    // Preload route on hover for faster navigation
    const handleMouseEnter = useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        preloadRoute(localizedPath);
        onMouseEnter?.(e);
      },
      [localizedPath, onMouseEnter]
    );
    
    return (
      <Link 
        ref={ref} 
        to={localizedPath} 
        onMouseEnter={handleMouseEnter}
        {...props}
      >
        {children}
      </Link>
    );
  }
);

LocalizedLink.displayName = 'LocalizedLink';